@if (order.status | snackbarHasOrderStatus: 'Canceled') {
  <div class="row mb-2">
    <div class="col-6 font-bold">{{ 'snackbar.snackbar-order-msg.canceled.title' | transloco }}</div>
    <div class="col-6 text-right">{{ order.cancelDate | date: 'mediumTime' }}</div>
  </div>
  <ng-container *ngTemplateOutlet="symbolRow; context: { order }" />
  @if (order.errorCode) {
    <div class="row mb-2">
      <div class="col-12">{{ 'order-error-code.' + order.errorCode | transloco }}</div>
    </div>
  }
  <div class="row">
    <div class="col-12">
      <a class="link-secondary cursor-pointer" (click)="repeatOrder()">{{ 'snackbar.snackbar-order-msg.canceled.repeat' | transloco }}</a>
    </div>
  </div>
  <hr />
}

@if (order.status | snackbarHasOrderStatus: 'Expired') {
  <div class="row mb-2">
    <div class="col-6 font-bold">{{ 'snackbar.snackbar-order-msg.expired.title' | transloco }}</div>
    <div class="col-6 text-right">{{ order.cancelDate | date: 'mediumTime' }}</div>
  </div>
  <ng-container *ngTemplateOutlet="symbolRow; context: { order }" />
  <div class="row">
    <div class="col-12">
      <a class="link-secondary cursor-pointer" (click)="repeatOrder()">{{ 'snackbar.snackbar-order-msg.expired.repeat' | transloco }}</a>
    </div>
  </div>
  <hr />
}

@if (order.status | snackbarHasOrderStatus: 'Rejected') {
  <div class="row mb-2">
    <div class="col-6 font-bold">{{ 'snackbar.snackbar-order-msg.rejected.title' | transloco }}</div>
    <div class="col-6 text-right">{{ order.cancelDate | date: 'mediumTime' }}</div>
  </div>
  <ng-container *ngTemplateOutlet="symbolRow; context: { order }" />
  @if (order.errorCode) {
    <div class="row mb-2">
      <div class="col-12">
        {{ 'order-error-code.' + order.errorCode | transloco }}
        @if (order.errorCode | orderShouldBeRepeated) {
          <br />{{ 'snackbar.snackbar-order-msg.rejected.repeat-msg' | transloco }}<br />
        }
      </div>
    </div>
    @if (order.errorCode | orderShouldBeRepeated) {
      <div class="row">
        <div class="col-12">
          <a class="link-secondary cursor-pointer" (click)="repeatOrder()">{{
            'snackbar.snackbar-order-msg.rejected.repeat' | transloco
          }}</a>
        </div>
      </div>
    }
  }
  <hr />
}

@if ((order.status | snackbarHasOrderStatus: 'Filled') && !(order.status | snackbarHasOrderStatus: 'Canceled')) {
  <div class="row mb-2">
    <div class="col-6 font-bold">
      {{ order.executedQuantity < order.quantity ? 'Order teilausgeführt' : 'Order ausgeführt' }}
    </div>
    <div class="col-6 text-right">{{ order.execDate | date: 'mediumTime' }}</div>
    @if (isDividendReinvest) {
      <div class="col-12">{{ 'snackbar.snackbar-order-msg.order-reason.dividend-reinvest' | transloco }}</div>
    }
  </div>
  <ng-container *ngTemplateOutlet="symbolRow; context: { order }" />
  <div class="row mb-2">
    <div class="col-6">
      @if (order.executedQuantity < order.quantity) {
        {{ order.executedQuantity | number: '1.0-8' }} (von {{ order.quantity | number: '1.0-8' }}) Stück zu &oslash;
        {{ order.execPrice | currency: 'EUR' : 'symbol' : '1.2-3' }}
      } @else {
        {{ order.executedQuantity | number: '1.0-8' }} Stück zu
        {{ order.execPrice | currency: 'EUR' : 'symbol' : '1.2-3' }}
      }
    </div>
    <div class="col-6 text-right font-bold">
      <span
        [class.text-color-error]="order.direction === 'buy' || orderExecutedValue < 0"
        [class.text-color-success]="order.direction === 'sell' && orderExecutedValue > 0"
      >
        {{ order.direction === 'buy' ? '-' : '' }}{{ orderExecutedValue | currency: 'EUR' : 'symbol' : '1.2-3' }}
      </span>
    </div>
  </div>

  @if (order.minimumQuantitySurcharge || order.fractionalSurcharge || order.provision) {
    <div class="row mb-2">
      @if (order.minimumQuantitySurcharge || order.fractionalSurcharge) {
        <div class="col-6">
          <span>Zuschlag</span>
          {{ (order.minimumQuantitySurcharge ?? 0) + (order.fractionalSurcharge ?? 0) | currency: 'EUR' : 'symbol' : '1.2-3' }}
        </div>
      }
      @if (order.provision) {
        <div class="col-6" [class.text-right]="order.minimumQuantitySurcharge || order.fractionalSurcharge">
          <span>Provision</span>
          {{ order.provision ?? 0 | currency: 'EUR' : 'symbol' : '1.2-3' }}
        </div>
      }
    </div>
  }

  <div class="row">
    <div class="col-12">
      <a class="link link-secondary cursor-pointer" (click)="oppositeOrder()">Entgegengesetzte Order</a>
    </div>
  </div>
  <hr />
}

<ng-template #symbolRow let-order="order">
  <div class="row mb-2">
    <div class="col-4">{{ order.direction | displayLabel }}</div>
    <div class="col-8 text-right">
      <a [routerLink]="instrumentDetails + '/' + order.isin">{{ order | shorthandSymbol: 'assetName' }}</a>
      @if (order | shorthandSymbol; as symbol) {
        <br />
        {{ symbol }}
      }
    </div>
  </div>
</ng-template>
